import { HttpHeaders } from '@angular/common/http';

export function getContentDisposition(headers: HttpHeaders) {
	const headerValue = headers.get('Content-Disposition');

	if (!headerValue) {
		return { fileName: null };
	}

	const contentDispositionValues = headerValue.split(';').map(v => v.trim());
	const filename = contentDispositionValues
		.find(v => v.startsWith('filename'))
		.split('=')[1]
		.replace(/(^"|"$)/g, ''); // Remove leading and trailing quotes
	return {
		filename,
	};
}
